export default {
  'claims': 'Claims',
  'claims_v2': 'Claims v2',
  'operationalReports': 'Operational Reports',
  'tireRackScorecard': 'Tire Rack Scorecard',
  'reports': 'Reports',
  'claimSearch': 'Claim Search',
  'claimSearch_v2': 'Claim Search v2',
  'dealerRegistration': 'Dealer Registration',
  'addProducts': 'Add Products',
  'registerDealer': 'Register Dealer',
  'dealerSubmissions': 'Dealer Submissions',
  'companies': 'Companies',
};